import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    itemContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    paginationContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    itemIcon: {
        justifyContent: "center",
        alignItems: "center",
        height: 48,
        width: 48
    },
    paginationButtonContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    itemInfoContainer: {
        flexDirection: "column",
        gap: 4
    },
    paginationJumpContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    headerRightContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    itemActionsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    itemContent: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    paginationJumpInput: {
        textAlign: "center",
        width: 80
    },
    listContentContainer: {
        flexGrow: 1
    },
    modalContent: {
        maxHeight: "80%",
        width: 500
    },
    itemActionEmpty: {
        width: 48
    },
    filterInput: {
        minWidth: 250
    },
    listContainer: {
        flex: 1
    },
    formContainer: {
    },
    modalActions: {
    },
    container: {
        flex: 1
    }
});

export default stylesheet;
